module.exports = __webpack_public_path__ + "static/media/rightpager.e3d1e831.svg";